import { useState } from "react";
import { ButtonBase, Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import ImageLoader from "../components/ImageLoader";
import { useNavigate } from "react-router-dom";

const TypesOfValues = ({ isMobile }) => {
  const navigate = useNavigate();

  const [selected, setSelected] = useState(null);

  const handleClick = (name) => {
    setSelected(name);
  };

  const selectedData = fulter.find((item) => item.name === selected);

  return (
    <Grid container sx={design.Back}>
      <Grid item size={design.Grid1} />

      <Grid item size={design.Grid3} alignSelf="center" pt={2}>
        {fulter.map((doc) => {
          const isActive = selected === doc.name;
          return (
            <Grid item key={doc.name}>
              <ButtonBase
                onClick={() => navigate("/visionMission")}
                sx={{
                  backgroundColor: isActive ? doc.color : "#fff",
                  border: `2px solid ${doc.color}`,
                  color: isActive ? "#fff" : doc.color,
                  ...design.ButtonBase,
                }}
              >
                {doc.name}
              </ButtonBase>
            </Grid>
          );
        })}
      </Grid>
      <Grid item size={design.Grid11} />
      <Grid item size={design.Grid11} />

      <Grid item size={design.Grid4} alignSelf="center">
        <ImageLoader
          src="https://centromedicomedam.com/IMG/centromedicoMEDAM/nuestros_valores_en_centro-medico_MEDAM.png"
          alt="nuestros_valores_en_centro-medico_MEDAM"
          width={"98%"}
          height={isMobile ? 259 : 365}
        />
      </Grid>
      <Grid item size={design.Grid11} />
      <Grid item size={design.Grid11} />
      <Grid item size={design.Grid3} alignSelf="center">
        <CustomText variant="subtitle1" color="#000" sx={design.TextTitulo}>
          Nuestros Valores
        </CustomText>
        <CustomText variant="subtitle1" color="#000" sx={design.Description}>
          En MEDAM, creemos que la ética es el corazón de toda práctica médica.
          Nuestros valores no solo nos definen, sino que marcan el camino hacia
          el tipo de atención en salud que queremos ofrecer: humana, responsable
          y de excelencia.
          <br />
          <br />
          Cada decisión, cada cuidado y cada servicio que brindamos está guiado
          por principios fundamentales que reflejan nuestro compromiso con los
          pacientes y con la comunidad
        </CustomText>
        {selectedData && (
          <CustomText
            variant="subtitle1"
            color={selectedData.color}
            sx={design.SelectedText}
          >
            {selectedData.description}
          </CustomText>
        )}
      </Grid>

      <Grid item size={design.Grid1} />
    </Grid>
  );
};

export default TypesOfValues;

const design = {
  TextTitulo: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 28,
      sm: 28,
      md: 28,
      lg: 35,
    },
    fontWeight: 700,
    textAlign: "left",
  },
  Description: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 15,
    lineHeight: "normal",
    marginTop: "2%",
    textAlign: "left",
  },
  SelectedText: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 15,
    marginTop: "3%",
    lineHeight: "normal",
    fontWeight: 500,
    textAlign: "left",
  },
  Back: {
    paddingBottom: 5,
  },
  ButtonBase: {
    borderRadius: "10px",
    fontWeight: 500,
    transition: "0.3s",
    fontSize: 18,
    marginTop: 1,
    marginBottom: 1,
    width: "95%",
    paddingTop: 2,
    paddingBottom: 2,
  },
  Grid1: { xs: 1, md: 1, xl: 1, lg: 1 },
  Grid11: { xs: 1, md: 0, xl: 0, lg: 0 },
  Grid3: { xs: 10, md: 3, xl: 3, lg: 3 },
  Grid4: { xs: 10, md: 4, xl: 4, lg: 4 },
};

const fulter = [
  { name: "Excelencia médica", color: "#00B327" },
  { name: "Cercanía y empatía", color: "#E36414" },
  { name: "Ética y profesionalismo", color: "#8638E5" },
  { name: "Innovación y mejora continua", color: "#2349D0" },
];
